import { createEntryPoint } from '#packages/apilib';
import { StudioMigrationManagerKey } from './publicApiKey';
import { StudioMigrationManagerApi } from './studioMigrationManagerApi';
import { StudioMigrationManagerScope } from './studioMigrationManagerScope';

export const StudioMigrationManagerEntryPoint = createEntryPoint({
  name: 'StudioMigrationManager',
  Scope: StudioMigrationManagerScope,
  publicApi({ contributeApi }) {
    contributeApi(StudioMigrationManagerKey, StudioMigrationManagerApi);
  },
});
